"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[61996],{

/***/ 70454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BackButton = function(param) {
    var isAppWebView = param.isAppWebView, _color = param.color, color = _color === void 0 ? "black" : _color, _top = param.top, top = _top === void 0 ? "top-4" : _top, _left = param.left, left = _left === void 0 ? "left-2" : _left;
    return null;
// const router = useRouter();
// if (!isAppWebView) {
//   return null;
// }
// return (
//   <button
//     onClick={() => router.back()}
//     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
//   >
//     <Image
//       src={
//         color == "white"
//           ? "/icons/left-arrow-white.svg"
//           : "/icons/left-arrow.svg"
//       }
//       alt="Geri"
//       width={32}
//       height={32}
//     />
//   </button>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _icons_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17601);
/* harmony import */ var _BackButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70454);





var BreadCrumb = function(param) {
    var data = param.data, isAppWebView = param.isAppWebView;
    if (data) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-brand-color-primary lg:bg-brand-blue-2 w-full relative py-4 mb-6 flex items-start gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                isAppWebView: isAppWebView,
                color: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pl-8 flex flex-col lg:flex-row flex-wrap items-center justify-center lg:justify-between w-full text-white",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "text-xl mm:text-2xl lg:text-4xl font-medium",
                            children: data.baslik
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex items-center gap-x-2 text-sm mm:text-base mt-1 lg:mt-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_icons__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
                                    name: "location",
                                    className: "hidden lg:inline-block"
                                }),
                                data.data.map(function(e, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: i > 0 ? "before:content-['/'] before:pr-2" : "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: e.url,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: e.title,
                                                children: e.name
                                            })
                                        })
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 61996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BreadCrumb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3605);
/* harmony import */ var _pbe_react_yandex_maps__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10738);
/* harmony import */ var _react_icons_all_files_gr_GrLocation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28471);
/* harmony import */ var _react_icons_all_files_gr_GrPhone__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5288);
/* harmony import */ var _react_icons_all_files_gr_GrShareOption__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22922);
/* harmony import */ var _react_icons_all_files_gr_GrFacebookOption__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53646);
/* harmony import */ var _react_icons_all_files_gr_GrTwitter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73985);
/* harmony import */ var _react_icons_all_files_gr_GrInstagram__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2168);
/* harmony import */ var _themes_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89507);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73040);













var Contact = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .m)(), contactAddress = ref.contactAddress, contactPhoneEmail = ref.contactPhoneEmail, contactShare = ref.contactShare, contactForm = ref.contactForm, contactFullName = ref.contactFullName, contactPhone = ref.contactPhone, contactEmail = ref.contactEmail, contactSubject = ref.contactSubject, contactMessage = ref.contactMessage, contactSecurityCode = ref.contactSecurityCode, contactSecurityCodeEnter = ref.contactSecurityCodeEnter, contactSendForm = ref.contactSendForm, contactMap = ref.contactMap;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BreadCrumb__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                data: ssr.result.BreadCrumb,
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "contact_item mb-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid lg:grid-cols-3 gap-7 mb-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-9 gap-y-2 shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrLocation__WEBPACK_IMPORTED_MODULE_6__/* .GrLocation */ .T, {
                                            className: "w-10 h-10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            className: "text-25 font-medium ".concat(_themes_themes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colorContent */ .Z.colorContent),
                                            children: contactAddress
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: ssr.result.adres
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-7 gap-y-2 shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrPhone__WEBPACK_IMPORTED_MODULE_7__/* .GrPhone */ .C, {
                                            className: "w-10 h-10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            className: "".concat(_themes_themes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colorContent */ .Z.colorContent, " text-25 font-medium"),
                                            children: contactPhoneEmail
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                ssr.result.phone,
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                " ",
                                                ssr.result.sitemail
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "contact_info flex flex-col items-center justify-center text-center py-9 px-6 gap-x-7 gap-y-2 shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrShareOption__WEBPACK_IMPORTED_MODULE_8__/* .GrShareOption */ .V, {
                                            className: "w-10 h-10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            className: "".concat(_themes_themes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colorContent */ .Z.colorContent, " text-25 font-medium"),
                                            children: contactShare
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-x-2",
                                            children: [
                                                ssr.result.facebook && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    href: ssr.result.facebook,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        title: "Villa Villam" + " Facebook",
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrFacebookOption__WEBPACK_IMPORTED_MODULE_9__/* .GrFacebookOption */ .f, {
                                                            className: "text-white"
                                                        })
                                                    })
                                                }),
                                                ssr.result.twitter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    href: ssr.result.twitter,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        title: "Villa Villam" + " Twitter",
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrTwitter__WEBPACK_IMPORTED_MODULE_10__/* .GrTwitter */ .X, {
                                                            className: "text-white"
                                                        })
                                                    })
                                                }),
                                                ssr.result.instagram && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    href: ssr.result.instagram,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        title: "Villa Villam" + " Instagram",
                                                        target: "_blank",
                                                        rel: "nofollow",
                                                        className: "w-9 h-9 flex items-center justify-center text-center bg-black ease-linear duration-200 hover:bg-[#3c3b3b] rounded-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_gr_GrInstagram__WEBPACK_IMPORTED_MODULE_11__/* .GrInstagram */ .Z, {
                                                            className: "text-white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-12 gap-x-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "lg:col-span-6 col-span-12 mb-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "item-form p-5 shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-25 font-semibold border-b border-black pb-1 mb-5",
                                                children: contactForm
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "grid sm:grid-cols-2 gap-x-5 mb-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold sm:mb-0 mb-2",
                                                                children: [
                                                                    contactFullName,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        autoComplete: "off"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold",
                                                                children: [
                                                                    contactPhone,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        autoComplete: "off"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "grid sm:grid-cols-2 gap-x-5 mb-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold sm:mb-0 mb-2",
                                                                children: [
                                                                    contactEmail,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        autoComplete: "off"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold",
                                                                children: [
                                                                    contactSubject,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        autoComplete: "off"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                        className: "flex flex-col font-semibold mb-5",
                                                        children: [
                                                            contactMessage,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                                                name: "mesaj",
                                                                className: "focus:outline-none border pl-2",
                                                                cols: "10",
                                                                rows: "5",
                                                                required: ""
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "grid sm:grid-cols-2 gap-x-5 mb-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold sm:mb-0 mb-2",
                                                                children: [
                                                                    contactSecurityCode,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "sayi",
                                                                        value: "1184",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        readOnly: true
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                className: "flex flex-col font-semibold",
                                                                children: [
                                                                    contactSecurityCodeEnter,
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                        type: "text",
                                                                        name: "name",
                                                                        className: "border border-1 focus:outline-none pl-2 py-2",
                                                                        autoComplete: "off"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        type: "submit",
                                                        className: "submitBtn w-full py-4 bg-green-500 hover:bg-[#28a745] ease-linear duration-200 font-semibold text-white rounded-md disabled",
                                                        children: contactSendForm
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "lg:col-span-6 col-span-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "item-map p-5 shadow-xl w-full h-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-25 font-semibold border-b border-black pb-1 mb-5",
                                                children: contactMap
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pbe_react_yandex_maps__WEBPACK_IMPORTED_MODULE_12__/* .YMaps */ .Yy, {
                                                className: "w-full h-full",
                                                query: {
                                                    lang:  true ? "en_US" : 0,
                                                    scroll: false
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pbe_react_yandex_maps__WEBPACK_IMPORTED_MODULE_12__/* .Map */ .D5, {
                                                    instanceRef: function(ref) {
                                                        ref && ref.behaviors.disable("scrollZoom");
                                                    },
                                                    width: "100%",
                                                    height: 366,
                                                    defaultState: {
                                                        center: [
                                                            36.6489397157294,
                                                            29.131687804566646
                                                        ],
                                                        zoom: 14
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pbe_react_yandex_maps__WEBPACK_IMPORTED_MODULE_12__/* .Placemark */ .ah, {
                                                            geometry: [
                                                                36.6489397157294,
                                                                29.131687804566646
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pbe_react_yandex_maps__WEBPACK_IMPORTED_MODULE_12__/* .ZoomControl */ .Ly, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ })

}]);